import api from './client'

export const propuestasVentaApi = {
  listar: (params = {}) => api.get('/propuestas-venta', { params }),
  obtener: (id) => api.get(`/propuestas-venta/${id}`),
  crear: (data) => api.post('/propuestas-venta', data),
  actualizar: (id, data) => api.put(`/propuestas-venta/${id}`, data),
  eliminar: (id) => api.delete(`/propuestas-venta/${id}`),
  duplicar: (id) => api.post(`/propuestas-venta/${id}/duplicar`),
  // Foto + precio sugerido de la lista + stock, para los artículos elegidos.
  articulosInfo: (lista, articuloIds) =>
    api.post('/propuestas-venta/articulos-info', { lista, articulo_ids: articuloIds }),
}
